import ReactTooltip from "react-tooltip";
import React, { Fragment } from "react";

const cellGenerator = ({ value, row: { index }, column: { id } }) => {
  let _value;
  _value = typeof value !== "string" ? JSON.stringify(value) : value;
  if (_value === undefined) {
    _value = "";
  }
  _value = _value.replace(/[\r\n]+/gi, " ").replace(/^\s+|\s+$/gi, "");
  return (
    <Fragment>
      <span title={_value} className="cell" data-tip data-for={`${id}${index}`}>
        {value}
      </span>
      <ReactTooltip id={`${id}${index}`} type="dark" effect="solid">
        <span>{_value}</span>
      </ReactTooltip>
    </Fragment>
  );
};

export default cellGenerator;
